<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:48
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-05 15:10:18
 * @FilePath: \huaxin-project-5\src\components\footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <footer>
    <div class="top">
      <div class="container">
        <div class="label-box">
          <img :src="this.$store.state.siteInfo.Logo" style="height: 60px;" />
        </div>
        <div class="item">
          <div class="item-box">
            <div class="label">联系邮箱</div>
            <div class="value">{{ this.$store.state.siteInfo.Email }}</div>
          </div>
          <div class="item-box">
            <div class="label">服务热线</div>
            <div class="value">{{ this.$store.state.siteInfo.Tel }}</div>
          </div>
          <div class="item-box">
            <div class="label">地址</div>
            <div class="value">{{ this.$store.state.siteInfo.Address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="container">
        <p>
          {{ this.$store.state.siteInfo.CopyRight }}

          <a :href="`https://beian.mps.gov.cn/#/query/webSearch?code=${this.$store.state.siteInfo.NS}`"
            v-if="this.$store.state.siteInfo.NS">
            <img src="@/assets/img/icon-footer.png" alt="" />
            浙公网安备{{ this.$store.state.siteInfo.NS }}号
          </a>
          <a href="https://beian.miit.gov.cn/" style="margin-left: 40px">{{
            this.$store.state.siteInfo.ICP
            }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "myfooter",
  props: {},
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;

  .top {
    height: 268px;
    background: url("~@/assets/img/home/13.png") no-repeat;
    background-size: 100% 100%;

    .container {
      padding-top: 30px;
      height: 100%;

      .label-box {
        height: 60px;
        line-height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;

        .xian {
          width: 1px;
          height: 16px;
          background: #cccccc;
          margin-left: 10px;
        }

        .label {
          font-size: 28px;
          font-weight: bold;
          color: #222222;
          margin-left: 20px;
        }

        .tit {
          margin-left: 10px;
          margin-right: 100px;
          font-size: 24px;
          color: #333333;
        }
      }

      .item {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 30px;

        .item-box {
          width: 315px;
          height: 78px;
          background: #e2e5e9;
          border-radius: 10px;
          border: 1px solid #f5f9fd;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .label {
            font-size: 14px;
            color: #999999;
          }

          .value {
            margin-top: 2px;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }
  }

  .bottom {
    margin-top: -20px;
    height: 60px;
    background: #8f97a4;

    .container {
      display: flex;
      height: 100%;
      font-size: 14px;
      justify-content: center;
      align-items: center;
      color: #ffffff;

      img {
        width: 16px;
        height: 17px;
        margin-left: 20px;
      }
    }
  }
}
</style>
